import { render, staticRenderFns } from "./ResumeAllocation.vue?vue&type=template&id=0cf673b8"
import script from "./ResumeAllocation.vue?vue&type=script&lang=js"
export * from "./ResumeAllocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cf673b8')) {
      api.createRecord('0cf673b8', component.options)
    } else {
      api.reload('0cf673b8', component.options)
    }
    module.hot.accept("./ResumeAllocation.vue?vue&type=template&id=0cf673b8", function () {
      api.rerender('0cf673b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/TalentQuery/SearchPage/ResumeAllocation.vue"
export default component.exports